import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import gDataTable from "@/components/g-data-table/g-data-table.vue"
import gPdf from "@/components/g-pdf/g-pdf.vue";
import { useVuelidate } from "@vuelidate/core";
import ClienteController from "@/shared/controllers/cliente/clienteController"
import PedidoAndamentoViewModel from "../../../shared/view-models/PedidoAndamentoViewModel";
import RepresentanteController from "@/shared/controllers/representante/representanteController"
import { defineComponent } from "vue"
import EVENTS from "@/shared/events/events"
import ProdutoController from "@/shared/controllers/produto/produtoController"
import AccountLoged from "@/shared/mixins/AccountLoged";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";
import PedidoController from "@/shared/controllers/pedido/PedidoController"

export default defineComponent({
  name:'PedidoEmAndamento',
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-steps': gSteps,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    PedidoEmAndamentoPDF
  },

  props: { },

  validations() {

  },

  mounted(){
    this.GetStatus(),
    this.getEnumTipoDescription()
    this.FiltroGetUnidade()
    this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId;
    this.PedidoAndamento.Unidade = this.$store.state.empresaSelecionadaId;


    this.ArrayRepresentantes = this.$store.state.RepresentanteArray;
    this.ArrayUnidade = this.$store.state.EmpresaArray;
    this.getEnumTipoDescription()
    this.FiltroGetUnidade()
    this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId;
    this.PedidoAndamento.Unidade = this.$store.state.empresaSelecionadaId;


    this.ArrayRepresentantes = this.$store.state.RepresentanteArray;
    this.ArrayUnidade = this.$store.state.EmpresaArray;
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId;
    });
  
    


    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId;
      this.PedidoAndamento.Unidade = this.$store.state.empresaSelecionadaId;
    });
//     this.popularDropDownEmpresa()
//     this.mitt.on('trocaEmpresaRepresentante', () => {
//       this.atualizaEmpresaRepresentante()
//     })

  },

  updated () { },

  data(){
    return {
      dataInicio: null,
      dataFinal: null,
      componentePedidoArray: [],
      executarvisualizacao: 0,
      formSearch: {
        numerosolicitacao: ''
      },
      linhaSelecionada: null,
      mensagemvazio: true,
      codigoPedido: undefined,
      pdfdownload: false,
      pdfvisualizacao: false,
      PedidoArray: [],
      timer: null,
      popup: false,
      ArrayClientes: [],
      ArrayRepresentantes: [],
      pedidoComponenteArray: [],
      renderiza: false,
      OrcamentoProdutoArray: [],
      Colunas : [
        //Campo dos dados , nome que aparece na página
        {field: 'pedidoParcela', header: 'Pedido/Parcela', width: '120px', ordena: true},
        {field: 'nomeProduto', header: 'Produto', width: '350px', ordena: true},
        {field: 'statusTexto', header: 'Status', width: '50px', ordena: true},
        {field: 'quantidadePedidoParcela', header: 'Qtd.Solicitada', width: '110px', ordena: true,alinha:'flex-end',type:'number'},
        {field: 'quantidadeProduzida', header: 'Qtd.Produzida', width: '80px', ordena: true,alinha:'flex-end',type:'number'},
        {field: 'quantidadeExpedida', header: 'Qtd.Expedida', width: '80px', ordena: true,alinha:'flex-end',type:'number'},
        {field: 'dataPedidoParcelaFormatada', header: 'Data da Entrega', width: '120px', ordena: true, ordenacao: 'dataEntregaFormatada',alinha:'center'},
        {field: 'saldo', header: 'Saldo', width: '80px', ordena: true,alinha:'flex-end',type:'number'},
      ],
      
      ColunasSubGridComponente: [
        { field: "componenteTipoTexto", header: "Componentes" },
        { field: "descricaoFaseProduto", header: "Fase de Produção" },
      ],

      PedidoAndamento: new PedidoAndamentoViewModel(),
      tipoPedidoArray: null,
      listaNotaFiscal: [],
      tipoSelecionado: null,
      ArrayUnidade: null,
      componentesExpandidos: null,
      consultaClienteAgrupador: null,
      ClienteAgrupadorAtiva: true,
      desabilitaBotaoCliente: true,
      ProdutoArray: null,
      representanteId: null,
      empresaId: null,
      StatusArray: [],
      podeBaixarPdf: false
    }
  },

  mixins:[AccountLoged],
  watch: {
    PedidoAndamento() {
      if (this.PedidoAndamento.Cliente == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  methods: {
    GetStatus(){
      PedidoController.GetStatusPedidoEnum()
      .requisicao.then((Response) => {
            let statusIncluidos = [1,2,3,4,5,8,10,9,13]
            this.StatusArray = Response.data.filter(x => statusIncluidos.includes(x.value))  
            this.StatusArray.unshift({
              text: 'TODOS',
              value: null
            })
          })
          .catch(() => {
          });
      },
    
    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },
    buscar() {
      this.getLogFaseDigitacao()
      this.$isLoading(true)
      this.mensagemvazio = false
      this.PedidoAndamento.RepresentanteId = this.$store.state.representanteSelecionadoId
      this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId

      this.axios ({
        method: "post",
        data: this.PedidoAndamento,
        url:
        process.env.VUE_APP_WEB_API + `Pedido/GetPedidoEmAndamento/`,
      })
      .then((response) => {
        this.PedidoArray = response.data.data || [];
        this.PedidoArray.forEach( x => {
          if(x.descricaoFaseProduto == 'OFF') {
            this.listaNotaFiscal.push(x.id)
          }
        })
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },


    detalhesPedido(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `pedido-em-andamento-fluxo/${data.pedidoId}/detalhes-pedido-andamento`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

    notasFiscaisRota(data) {
      this.$router.push(`/notas-fiscais/${data.codigoPedido}`)
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },

    imprimir(data) {
      this.renderiza = true

      this.linhaSelecionada = data.id

      setTimeout(() => {
        this.podeBaixarPdf = true
      }, 600);
    },

    clear () {
      this.PedidoAndamento = new PedidoAndamentoViewModel();
      this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId;
      this.PedidoAndamento.Unidade = this.$store.state.empresaSelecionadaId;
      this.PedidoAndamento.RepresentanteId = this.$store.state.representanteSelecionadoId
    },

    FiltroGetClientes (valor) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
      ClienteController.getClienteDropDownsByNome(valor, this.PedidoAndamento.Unidade, this.PedidoAndamento.Representante).requisicao
        .then((Response) => {
          this.ArrayClientes = Response.data.data;
        })
        .catch(() => {
        })
      }, 1100);
    },

    FiltroGetUnidade () {
      this.ArrayUnidade = this.$store.state.EmpresaArray;
    },

    FiltroGetRepresentante (valor) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
      RepresentanteController.getRepresentanteByPesquisa(this.PedidoAndamento.Unidade, valor).requisicao
        .then((Response) =>{
          if(Response.data.data == null){
            this.ArrayRepresentantes = [];
            return
          }
          this.ArrayRepresentantes = Response.data.data;
        })
      }, 1100);
    },

    getEnumTipoDescription () {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + "pedido/GetTipoPedidoEnum",
      })
      .then((response) => {
        this.tipoPedidoArray = response.data;
      })
      .catch(() => {});
    },

    redirecionaNotaFiscal(linhaSelecionada) {
      linhaSelecionada
      this.$router.push(`/notas-fiscais`)
    },

    habilitarCheckCliente() {
      this.desabilitaBotaoCliente = false
    },

    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.PedidoAndamento.Unidade).requisicao
        .then((res) => {

          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    getCodigo(produtoId){
      ProdutoController.GetCodigoByProdutoId(produtoId).requisicao
        .then((res) => {
          this.PedidoAndamento.Codigo = res.data.message

        })
        .catch(() => {
        })
    },

    atualizaEmpresaRepresentante(){
      this.PedidoAndamento.Unidade = this.$store.state.empresaSelecionadaId;
      this.PedidoAndamento.Representante = this.$store.state.representanteSelecionadoId;
    },

    popularDropDownEmpresa(){
      this.atualizaEmpresaRepresentante()
    },

    getLogFaseDigitacao(){
        this.axios({
          method: "get",
          url: 
            process.env.VUE_APP_WEB_API +
            `Pedido/getLogFaseDigitacao/`,
        }).then(() => {
        })
    },

    buscarProdutoNovo(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoNovoByPesquisaRepresentante(pesquisa, this.$store.state.representanteSelecionadoId, this.PedidoAndamento.Unidade).requisicao
        .then((res) => {
          this.OrcamentoProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },
  },


  computed: { }

});